import { TPromisePopupProps } from '@@types/popup';
import {
  Button,
  DrawerBody,
  DrawerContent,
  DrawerHeader,
} from '@chakra-ui/react';
import { signIn } from 'next-auth/react';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaLine } from 'react-icons/fa';

export default function SignInDrawer({
  props,
  closePopup,
}: TPromisePopupProps) {
  const [isLoading, setIsLoading] = useState(false);
  const router = useRouter();
  const { i18n } = useTranslation();

  const handleSignIn = async () => {
    setIsLoading(true);
    try {
      const pid = router.query.pid as string;
      const [_, obj] = pid.split('@');
      const parsed = JSON.parse(obj);
      const stepObj = {
        ...parsed,
        props: { ...parsed.props, step: 'payment' },
      };

      const isSignIn = await signIn('line', {
        redirect: false,
        callbackUrl:
          window.location.origin +
          '?' +
          `lang=${i18n.language}` +
          '&' +
          `pid=cart@${JSON.stringify(stepObj)}`,
        country: i18n.language,
      });

      props.resolve(isSignIn);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <DrawerContent>
      <DrawerHeader textAlign="center">Log In</DrawerHeader>
      <DrawerBody className="min-h-[30vh]">
        <Button
          onClick={handleSignIn}
          className={`w-full bg-[#1AB953] text-white flex items-center p-0 overflow-hidden relative text-center ${
            isLoading ? 'justify-center' : 'justify-start'
          }`}
          size="md"
          isLoading={isLoading}
        >
          <p className="basis-[10%] w-full px-[20px]">
            <FaLine color="white" size="32px" />
          </p>
          <p className="w-full absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]">
            Continue with Line
          </p>
        </Button>
      </DrawerBody>
    </DrawerContent>
  );
}
